// extracted by mini-css-extract-plugin
export var paragraph = "RichText-module--paragraph--Uzyv7";